import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-web-style-top-bar',
    templateUrl: './web-style-top-bar.component.html',
    styleUrls: ['./web-style-top-bar.component.scss'],
    standalone: false
})
export class WebStyleTopBarComponent {
  @Input() pageTitle!: string;
}
